import "./StatisticalInformation.scss";
import { addCommas } from "@persian-tools/persian-tools";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { BsListCheck } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import logoGM from "assets/images/sitelogo.svg";
import AuthContext from "Authentication/AuthenticationContext.ts";
import { useContext, useEffect } from "react";
import { sendRequestAPI2 } from "hooks/useAxios";
import { useParams } from "react-router-dom";
import toastFunction from "utils/toast";

import { FcInfo } from "react-icons/fc";
import { toast } from "react-toastify";
export default function StatisticalInformation({
  productInfo,
  setProductInfo,
  typeUser,
  updater,
  setUpdater,
  stortype,
  type,
  userType,
}) {
  console.log("usertype", userType);
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  const date = new Date();
  const statusPreview = (status) => {
    switch (status) {
      case 0:
        return "درانتظار اتمام خرید";
        break;
      case 1:
        return "در حال پردازش سفارشات";
        break;
      case 2:
        return "اتمام سفارش";
        break;
      case -1:
        return "کنسل(تکمیل نشدن رنج)";
        break;
      case -2:
        return "کنسل(توسط سوپر ادمین)";
        break;
      default:
        return "نامشخص";
    }
  };
  const cancellation = () => {
    sendRequestAPI2("group_sale_change_status", {
      cancel: "1",
      pbl_id: productInfo.id,
    }).then(({ data }) => {
      if (data.status == 1) {
        toastFunction("success", "فروش گروهی با موفقیت کنسل شد");
        setUpdater((prev) => !prev);
        console.log("cancellation", data);
      } else if (data.status == -1) {
        toastFunction("error", "عملیات با خطا مواجه شد");
      }
    });
  };
  const Termaination = () => {
    sendRequestAPI2("group_sale_change_status", {
      cancel: "0",
      pbl_id: productInfo.id,
    }).then(({ data }) => {
      if (data.status == 1) {
        toastFunction("success", "  اتمام فروش با موفقیت ثبت شد   .");

        setUpdater((prev) => !prev);
        console.log("Termainationa", data);
      } else if (data.status == -1) {
        toastFunction("error", "اتمام فروش با خطا مواجه شد");
      }
    });
  };

  const activeRange = productInfo.range.find((value) => value.is_active == "1");

  return (
    <div className="description-sta mt-3 statistic mx-0 ">
      {/* <div className="row p-4 m-0 box-statistical mx-0">
        <div className="col-6 box-col">
          <label className="label"> تعدادفروش : </label>

          {activeRange?.from_count && activeRange?.saled_count ? (
            <span className="txt">
              {activeRange.saled_count}
            </span>
          ) : (
            <span className="txt">---</span>
          )}
        </div>
        <div className="col-6  box-col">
          <label className="label"> مجموع مبلغ پرداخت شده : </label>

          <span className="txt">
            {addCommas(productInfo.totalAmountPaid || 0)}
          </span>
        </div>
        <div className="col-6 box-col mt-3">
          <label className="label"> قیمت فعلی فروش : </label>
          {activeRange?.from_price && activeRange?.is_active == "1" ? (
            <span className="txt">
              {addCommas(activeRange.from_price)} تومان
            </span>
          ) : (
            <span className="txt">---</span>
          )}
        </div>
        <div className="col-6 box-col mt-3">
          <label className="label"> مجموع سود خریداران : </label>

          <span className="txt">
            {addCommas(productInfo.totalAmountdiscount || 0)}
          </span>
        </div>
      </div> */}
      {date > productInfo.group_sale_endtime ? (
        <div className="row ">
          <div className="col-12 col-md-4 align-self-center">
            <div className="d-flex conStatus">
              <label className="labelStatus">
                {" "}
                {/* <FcInfo></FcInfo> */}
                وضعیت :
              </label>
              <lable className="txtStatus">
                {" "}
                {statusPreview(productInfo.product_pricing_status)}
              </lable>
            </div>
          </div>
          <div className="col-12 col-md-8  mt-3  mx-0">
            <div className="d-flex  container-btn">
              <>
                {auth.userInfo.userType == "0" ||
                (type == "superAdmin" &&
                  productInfo.product_pricing_status === 0) ? (
                  <>
                    <button
                      type="buttom"
                      className="btn-saleEnd"
                      onClick={() => {
                        Swal.fire({
                          title: "آیا از کنسل کردن فروش گروهی مطمئن هستید؟",
                          imageUrl: logoGM,
                          showDenyButton: true,
                          // showCancelButton: true,
                          confirmButtonText: "بله",
                          denyButtonText: `خیر`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            cancellation();

                            //navigate("/");
                          }
                        });
                      }}
                    >
                      <span>
                        <AiOutlineClose></AiOutlineClose>
                      </span>
                      <span> کنسل کردن </span>
                    </button>
                    <button
                      type="buttom"
                      className="btn-saleEnd"
                      onClick={() => {
                        Swal.fire({
                          title: "آیا از اتمام فروش مطمئن هستید؟",
                          imageUrl: logoGM,
                          showDenyButton: true,
                          // showCancelButton: true,
                          confirmButtonText: "بله",
                          denyButtonText: `خیر`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            Termaination();
                            //navigate("/");
                          }
                        });
                      }}
                    >
                      <span>
                        <AiOutlineClose></AiOutlineClose>
                      </span>
                      <span> اتمام فروش</span>
                    </button>
                  </>
                ) : (
                  ""
                )}
              </>

              <>
                {(type == "superAdmin" || stortype == "1") && (
                  <NavLink
                    to={`/admin-panel/FactorList/${productInfo.product_id}/${productInfo.business[0].id}/${productInfo.range[0].mtm}/${userType}`}
                    target="_blank"
                  >
                    <button
                      type="buttom"
                      className="btn-factorList"
                      // onClick={() => (
                      //   navigate(
                      //     `/admin-panel/FactorList/${productInfo.product_id}/${productInfo.business[0].id}/${productInfo.range[0].mtm}`
                      //   )

                      // )}
                    >
                      <span>
                        <BsListCheck></BsListCheck>
                      </span>
                      <span> لیست فاکتورها</span>
                    </button>
                  </NavLink>
                )}
              </>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
